<template>
  <div>
    <v-data-table
      :headers="visualizarPontosMedalha ? headers : headersSemPontos"
      :items="perguntasEvidenciadas"
      class="elevation-1"
      hide-default-footer
      disable-pagination
      :expanded.sync="expanded"
      item-key="perguntaMunicipioId"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.nome }}</td>
          <td>
            <div>
              <div>{{ props.item.texto }}</div>
            </div>
          </td>
          <td
            @click="() => $emit('openEvidence', props.item)"
            v-if="props.item.temArquivo"
          >
            <div class="optionsExpanded">
              <v-btn
                color="azulclarosc"
                class="ml-3"
                style="color: #fff"
                v-if="
                  isFullAdmin ||
                  (groupsConfig.visualizarRejeitadas &&
                    config.visualizarRejeitadas)
                "
              >
                <span
                  v-if="
                    expanded.length > 0 &&
                    props.item.perguntaMunicipioId ===
                      expanded[0].perguntaMunicipioId
                  "
                  >esconder arquivos</span
                >
                <span v-else>mostrar arquivos</span>
              </v-btn>
            </div>
          </td>
          <td v-else></td>
          <td></td>
          <td v-if="props.item.evidencia">
            <app-modal-show-evidence
              :evidence="props.item.evidencia"
              :color="'primary'"
              :isHtml="isSala ? true : false"
            >
            </app-modal-show-evidence>
          </td>
          <td v-else></td>
          <td>
            <v-btn
              v-if="props.item.perguntaId == 3"
              color="azulclarosc"
              style="color: #fff"
              class="ml-3"
              @click="visualizarComplemento = !visualizarComplemento"
            >
              Complemento
            </v-btn>
          </td>
        </tr>

        <tr
          class="complemento"
          v-if="visualizarComplemento && props.item.perguntaId == 3"
        >
          <td colspan="8">
            <h1 class="titulo">Dados complementários obrigatórios</h1>
            <div>
              <div class="d-flex perguntas">
                <div class="_nome">
                  Mínimo de horas por atendente informado no(s) arquivo(s)
                  carregados acima (incluindo as 04 horas mínimas de capacitação
                  em Compras Governamentais)
                </div>

                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="props.item.valorInformado"
                    outlined
                    readonly
                    placeholder="0"
                    hide-details="auto"
                  ></v-text-field>
                </div>
              </div>
              <hr />
              <div class="d-flex perguntas">
                <div class="_nome">
                  Quantidade de atendentes informada no
                  <strong>diagnóstico</strong>
                </div>
                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="valorDiagnostico"
                    outlined
                    placeholder="0"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </div>
              </div>
              <hr />
              <div class="d-flex perguntas">
                <div class="_nome">Quantidade atual de atendentes</div>
                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="props.item.atualizacaoAtendentes"
                    outlined
                    placeholder="0"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="props">
        <tr
          v-if="
            isFullAdmin ||
            (groupsConfig.visualizarEvidenciadas &&
              config.visualizarEvidenciadas)
          "
        >
          <td colspan="8" class="p-0">
            <app-get-evidence-question
              :perguntaId="props.item.perguntaMunicipioId"
              @updateValue="$emit('updateValue')"
              :evidences="evidences"
              :type="'Evidenciadas'"
              @finalizar="openModal(props.item)"
            ></app-get-evidence-question>
            <modal-finalizar
              @close="closeModal"
              :dialog="dialog"
              ref="modalFaixa"
              :itens="props.item"
              @finalizar="finalizarAvalicao"
            ></modal-finalizar>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <span> Nenhuma pergunta retornada </span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { mapActions, mapGetters } from "vuex";
import AppGetEvidenceQuestion from "@/modules/evidence/components/selo/GetQuestionSelo";
import Swal from "sweetalert2";
import { evidenceQuestionAPI } from "@/modules/evidence/API/EvidenceQuestionAPI";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import ModalFinalizar from "./ModalFinalizar.vue";

export default {
  components: {
    AppModalShowEvidence,
    AppGetEvidenceQuestion,
    ModalFinalizar,
  },
  props: {
    visualizarPontosMedalha: { type: Boolean, required: true },
    perguntasEvidenciadas: { type: Array, required: true },
    headers: { type: Array, required: true },
    headersSemPontos: { type: Array, required: true },
    payload: { type: Object, Array: true },
    rulesArquivo: { type: Array, required: true },
    expanded: { type: Array, required: true },

    evidences: { type: Array },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      visualizarComplemento: false,
      valorDiagnostico: 0,
      dialog: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    invalidEvidencias() {
      let aprovadas = this.evidences.filter((item) => item.aprovada);
      let rejeitadas = this.evidences.filter((item) => item.rejeitada);
      let respondidas = aprovadas.length + rejeitadas.length;

      if (this.evidences.length != respondidas) {
        Swal.fire({
          title: "Campos obrigatórios",
          text: `É necessário fazer a análise de todas as evidências antes de finaliza-las. Por favor verifique as evidências que faltam.`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return true;
      }

      return false;
    },
    getRespostaDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(this.isParceiro ? 106 : 133, this.$route.params.id)
        .then((resp) => {
          this.valorDiagnostico =
            resp.data && resp.data.length && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    finalizarAvalicao(faixa) {
      this.setLoading(true);

      const a = this.evidences
        .filter((item) => !item.enviada)
        .map((val) => ({ ...val, perguntaFaixaRespostaId: faixa.faixaId }));

      evidenceQuestionAPI
        .finalizarAnalise(a)
        .then(() => {
          this.$emit("load");
          this.dialog = false;
        })
        .catch((err) => {
          this.dialog = false;
          console.log("err: ", err);
        });
    },
    openModal(item) {
      if (this.invalidEvidencias()) return;

      this.dialog = true;
    },

    closeModal() {
      this.dialog = false;
    },
  },
  mounted() {
    this.getRespostaDiagnostico();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isSala",
      "isAnalista",
      "isFullAdmin",
      "isParceiro",
    ]),
  },
};
</script>
<style>
.complemento .v-input__control {
  background: #fff;
}

.pergunta3 .v-file-input__text {
  color: #fff !important;
}
.pergunta3 .v-text-field .v-label {
  color: #f5f5f5 !important;
}
</style>
<style scoped lang="scss">
.evidencias {
  padding: 10px 30px !important;
  .titulo2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .nomeEvidencia {
    cursor: pointer;
    color: #2d6189;
    font-weight: bold;
  }

  .nomeEvidencia:not(:last-of-type) {
    border-right: 1px solid #dfdfdf;
    padding-right: 20px;
  }

  .agrupEvidencias {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
  }
}

.pergunta3 {
  background: #2d6189;
  color: #fff;
}
.pergunta3:hover {
  background: #3d6788 !important;
  color: #fff;
}
.complemento {
  background: #f5f5f5;
}
.complemento td {
  padding: 10px 30px !important;
}
.titulo {
  font-size: 20px;
  margin: 1rem 0;
}
.perguntas {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;

  ._nome {
    max-width: 70%;
  }
}
</style>
